import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import CheckProducts from '../front_stage/check_products_controller'
import ClearConversionCookies from '../front_stage/clear_conversion_cookies_controller'
import CompareSeeMore from '../front_stage/compare_see_more_controller'
import ConditionalState from '../front_stage/conditional_state_controller'
import ConsultantFormValid from '../front_stage/consultant_form_valid_controller'
import DetailsWithModal from '../front_stage/details_with_modal_controller'
import FollowUp from '../front_stage/follow_up_controller'
import FooterScroll from '../front_stage/footer_scroll_controller'
import FormUnsavedConfirm from '../front_stage/form_unsaved_confirm_controller'
import InputBox from '../front_stage/input_box_controller'
import PlanTabs from '../front_stage/plan_tabs_controller'
import PostCode from '../front_stage/post_code_controller'
import Pulldown from '../front_stage/pulldown_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'
import TabPanel from '../front_stage/tab_panel_controller'
import TransformHalfFont from '../front_stage/transform_half_font_controller'
import HideEmptyContentElement from '../front_stage/hide_empty_content_element_controller'
import Benefit from '../front_stage/benefit_controller'
import RemoveHyphen from '../front_stage/remove_hyphen_controller'
import NormalizeTel from '../front_stage/normalize_tel_controller'

application.register('check-products', CheckProducts)
application.register('clear-conversion-cookies', ClearConversionCookies)
application.register('compare-see-more', CompareSeeMore)
application.register('conditional-state', ConditionalState)
application.register('consultant-form-valid', ConsultantFormValid)
application.register('details-with-modal', DetailsWithModal)
application.register('follow-up', FollowUp)
application.register('footer-scroll', FooterScroll)
application.register('form-unsaved-confirm', FormUnsavedConfirm)
application.register('input-box', InputBox)
application.register('plan-tabs', PlanTabs)
application.register('post-code', PostCode)
application.register('pulldown', Pulldown)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('structured-data-faq', StructuredDataFaq)
application.register('tab-panel', TabPanel)
application.register('transform-half-font', TransformHalfFont)
application.register('hide-empty-content-element', HideEmptyContentElement)
application.register('benefit', Benefit)
application.register('remove-hyphen', RemoveHyphen)
application.register('normalize-tel', NormalizeTel)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
